/**
 * Valuation Automatic — drafts / CEP / locate / access (RQ-093 / RQ-103).
 * Client isolado para build limpo (não depende de exports órfãos em index.js).
 */

const API_BASE = (typeof window !== "undefined" && window.location?.origin ? (/^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname) ? window.location.origin : (process.env.REACT_APP_API_BASE || window.location.origin)) : (process.env.REACT_APP_API_BASE || "https://brengenhariaconsultiva.com.br"));

function getToken() {
  try {
    return localStorage.getItem("token") || localStorage.getItem("access_token") || "";
  } catch {
    return "";
  }
}

async function valuationAutomaticFetch(path, options = {}) {
  const token = getToken();
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {})
    }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data?.detail;
    const msg =
      typeof detail === "string"
        ? detail
        : detail?.message || data?.message || `Erro Valuation Automatic (${response.status})`;
    const err = new Error(msg);
    err.status = response.status;
    err.detail = detail;
    err.payload = data;
    throw err;
  }
  return data;
}

export async function valuationAutomaticAccess() {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/access");
}

export async function valuationAutomaticCepResolve(cep) {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/cep/resolve", {
    method: "POST",
    body: JSON.stringify({ cep })
  });
}

export async function valuationAutomaticAddressSuggest(payload) {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/address/suggest", {
    method: "POST",
    body: JSON.stringify(payload || {})
  });
}

export async function valuationAutomaticLocate(payload) {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/locate", {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export async function valuationAutomaticMunicipios(uf) {
  return valuationAutomaticFetch(
    `/api/v1/valuation-automatic/municipios?uf=${encodeURIComponent(uf)}`
  );
}

export async function valuationAutomaticCreateDraft(payload) {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/drafts", {
    method: "POST",
    body: JSON.stringify({ payload })
  });
}

export async function valuationAutomaticSaveDraft(draftId, payload, opts = {}) {
  const body = { payload };
  if (opts.expectedVersion != null) body.expected_version = opts.expectedVersion;
  return valuationAutomaticFetch(`/api/v1/valuation-automatic/drafts/${encodeURIComponent(draftId)}`, {
    method: "PUT",
    body: JSON.stringify(body)
  });
}

export async function valuationAutomaticGetDraft(draftId) {
  return valuationAutomaticFetch(`/api/v1/valuation-automatic/drafts/${encodeURIComponent(draftId)}`);
}

export async function valuationAutomaticListDrafts() {
  return valuationAutomaticFetch("/api/v1/valuation-automatic/drafts");
}


export async function valuationAutomaticDeleteDraft(draftId) {
  return valuationAutomaticFetch(`/api/v1/valuation-automatic/drafts/${encodeURIComponent(draftId)}`, {
    method: "DELETE"
  });
}


export async function valuationAutomaticIptuLookup(params = {}) {
  const qs = new URLSearchParams();
  if (params.sql) qs.set("sql", String(params.sql));
  if (params.cep) qs.set("cep", String(params.cep));
  if (params.logradouro) qs.set("logradouro", String(params.logradouro));
  if (params.numero) qs.set("numero", String(params.numero));
  if (params.unidade) qs.set("unidade", String(params.unidade));
  return valuationAutomaticFetch(`/api/v1/valuation/iptu-lookup?${qs.toString()}`);
}

export const valuationAutomaticCadastralLookup = valuationAutomaticIptuLookup;

export const valuationAutomaticCepSearchByAddress = valuationAutomaticAddressSuggest;
